import {BS} from '../../../../types/BS_types'

export const isActiveClassicUILink = (page: string): boolean =>
  BS?.topNavPane?.getActiveTab()?.myTabId === page
